import React, { useEffect, useState } from "react";

// Anchored sub-navigation for long pages: a quiet pill row that tracks the section in view.
export function SubNav({ items, testId = "e2-subnav" }) {
  const [active, setActive] = useState(items[0]?.id);

  useEffect(() => {
    const els = items.map((i) => document.getElementById(i.id)).filter(Boolean);
    if (!els.length) return;
    const io = new IntersectionObserver(
      (entries) => {
        const vis = entries.filter((e) => e.isIntersecting).sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
        if (vis[0]) setActive(vis[0].target.id);
      },
      { rootMargin: "-40% 0px -50% 0px", threshold: 0 }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, [items]);

  const go = (e, id) => {
    e.preventDefault();
    const el = document.getElementById(id);
    if (!el) return;
    const top = el.getBoundingClientRect().top + window.scrollY - 120;
    window.scrollTo({ top, behavior: "smooth" });
    setActive(id);
  };

  return (
    <nav className="e2-subnav" aria-label="On this page" data-testid={testId}>
      <div className="e2-subnav-inner">
        <span className="e2-subnav-label">On this page</span>
        {items.map((it) => (
          <a
            key={it.id}
            href={`#${it.id}`}
            onClick={(e) => go(e, it.id)}
            aria-current={active === it.id ? "location" : undefined}
            data-testid={`${testId}-${it.id}`}
          >
            {it.label}
          </a>
        ))}
      </div>
    </nav>
  );
}
